import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import { IFormItemProps } from '../../types/components/form';
import { ICheckboxLayout } from '../../types/layout/checkbox';

function Checkbox({
    disabled, label, value, onChange,
}: ICheckboxLayout & IFormItemProps) {
    const id = uuidv4();

    const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        onChange(e.target.checked);
    };

    return (
        <div className="form-check">
            <input className="form-check-input" disabled={disabled} type="checkbox" id={id} checked={value} onChange={onChangeHandler} />
            <label className="form-check-label" htmlFor={id}>{label}</label>
        </div>
    );
}

export default Checkbox;
